import { UnifiedLogin } from 'Application/pages';
import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import { AuthRedirectRoute } from './AuthRedirectRoute';



// login option 2 routing
// const AuthLogin2 = Loadable(lazy(() => import('views/pages/authentication/authentication2/Login2')));
// const AuthRegister2 = Loadable(lazy(() => import('views/pages/authentication/authentication2/Register2')));
const AuthForgotPassword2 = Loadable(lazy(() => import('Application/pages/shared/auth/authentication/authentication2/ForgotPassword2')));
const AuthCheckMail2 = Loadable(lazy(() => import('Application/pages/shared/auth/authentication/authentication2/CheckMail2')));
const AuthResetPassword2 = Loadable(lazy(() => import('Application/pages/shared/auth/authentication/authentication2/ResetPassword2')));
const AuthCodeVerification2 = Loadable(lazy(() => import('Application/pages/shared/auth/authentication/authentication2/CodeVerification2')));
const AuthSetPassword2 = Loadable(lazy(() => import('Application/pages/shared/auth/authentication/authentication2/SetPassword')));



// maintenance routings
const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));
const MaintenanceError500 = Loadable(lazy(() => import('views/pages/maintenance/Error500')));
const MaintenanceComingSoon1 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon1')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon2')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));

// landing & contact-us routing
const PagesLanding = Loadable(lazy(() => import('views/pages/landing')));
const PagesContactUS = Loadable(lazy(() => import('views/pages/contact-us')));
const PagesFaqs = Loadable(lazy(() => import('views/pages/saas-pages/Faqs')));
const PagesPrivacyPolicy = Loadable(lazy(() => import('views/pages/saas-pages/PrivacyPolicy')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    children: [
        {
            path: '/auth/login',
            element: <AuthRedirectRoute component={<UnifiedLogin />} />
        },

        {
            path: '/auth/forgot-password',
            element: <AuthRedirectRoute component={<AuthForgotPassword2 />} /> 
        },
        {
            path: '/auth/check-mail',
            element: <AuthRedirectRoute component={<AuthCheckMail2 />} /> 
        },
        {
            path: '/auth/reset-password',
            element: <AuthRedirectRoute component={<AuthResetPassword2 />} /> 
        },
        {
            path: '/auth/set-password',
            element: <AuthRedirectRoute component={<AuthSetPassword2 />} /> 
        },
        {
            path: '/auth/confirm-login',
            element: <AuthRedirectRoute component={<AuthCodeVerification2 />} /> 
        },




        {
            path: '/pages/error',
            element: <MaintenanceError />
        },
        {
            path: '/pages/500',
            element: <MaintenanceError500 />
        },
        {
            path: '/pages/coming-soon1',
            element: <MaintenanceComingSoon1 />
        },
        {
            path: '/pages/coming-soon2',
            element: <MaintenanceComingSoon2 />
        },
        {
            path: '/pages/under-construction',
            element: <MaintenanceUnderConstruction />
        },

        {
            path: '/pages/landing',
            element: <PagesLanding />
        },
        {
            path: '/pages/contact-us',
            element: <PagesContactUS />
        },
        {
            path: '/pages/faqs',
            element: <PagesFaqs />
        },
        {
            path: '/pages/privacy-policy',
            element: <PagesPrivacyPolicy />
        }
    ]
};

export default AuthenticationRoutes;
